"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ContactPopper;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));
var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));
function ContactPopper(_ref) {
  var anchorEl = _ref.anchorEl,
    name = _ref.name,
    subject = _ref.subject,
    recipients = _ref.recipients,
    text = _ref.text;
  var open = Boolean(anchorEl);
  var id = open ? 'contact-popper' : undefined;
  return /*#__PURE__*/_react["default"].createElement(_Popper["default"], {
    transition: true,
    id: id,
    className: "z-50",
    open: open,
    anchorEl: anchorEl,
    placement: "bottom-start"
  }, function (_ref2) {
    var TransitionProps = _ref2.TransitionProps;
    return /*#__PURE__*/_react["default"].createElement(_Fade["default"], (0, _extends2["default"])({}, TransitionProps, {
      timeout: 350
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "shadow-hover p-4 bg-card mt-4 break-words",
      style: {
        width: 500
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-xs font-semibold"
    }, name), /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-sm text-gray-dark font-semibold truncate-3"
    }, subject), /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-sm py-2"
    }, recipients), /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-sm"
    }, text)));
  });
}
//# sourceMappingURL=ContactPopper.js.map